import gql from 'graphql-tag'

export default config => async payload => {
  const {
    client,
    table,
    alias = 'item',
    primaryKey,
    defaultOutput,
    defaultFragments
  } = config

  const { output = defaultOutput, fragments = defaultFragments || '' } = payload

  let pk_columns = primaryKey.map(name => {
    if (!payload[name]) throw new Error(`${table} - ${name} is undefined`)
    return `${name}: "${payload[name]}"`
  })

  const mutation = gql`
     mutation {
        ${alias}: delete_${table}_by_pk(${pk_columns.join(',')}) {
            ${primaryKey.join(' ')}
        }
      }
      ${fragments}
    `

  const { data } = await client.mutate({
    mutation
  })

  return data[alias]
}
